import { graphql } from '@/gql'

export const GetRecruiterCandidatesQuery = graphql(/* GraphQL */ `
  query recruiterCandidates($accounts: [ID!], $first: Int) {
    recruiterCandidates(accounts: $accounts, first: $first) {
      data {
        ...RecruiterCandidateFragment
      }
    }
  }
`)

export const GetAvailableRecruiterCandidatesQuery = graphql(/* GraphQL */ `
  query availableRecruiterCandidates($accounts: [ID!], $rateType: RateType, $currency: String) {
    recruiterCandidates(accounts: $accounts, status: ACTIVE) {
      data {
        ...PitchingRecruiterCandidateFragment
      }
    }
  }
`)
